export enum TargetMarketId {
  AUSTRALIA = 36,
  CHILE = 152,
  FRANCE = 250,
  GERMANY = 276,
  GLOBAL_MARKET = 1,
  IRELAND = 372,
  PORTUGAL = 620,
  REUNION = 638,
  SPAIN = 724,
  SWITZERLAND = 756,
  UNITED_KINGDOM = 826,
  UNITED_STATES = 840,
  CANADA = 124,
  MEXICO = 484,
  COLOMBIA = 170,
  PERU = 604,
  COSTA_RICA = 188,
  BRAZIL = 76,
}

export interface TargetMarket {
  id: number;
  [key: string]: any;
}
